var _path, _path2, _path3, _ellipse, _ellipse2, _ellipse3, _path4, _path5, _circle, _circle2, _circle3, _path6, _path7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgScratchHeaderRight = function SvgScratchHeaderRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 227,
    height: 122,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5F01",
    d: "M171.982 17.207L195.715 4l5.983 10.805-23.733 13.207z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#368FFE",
    d: "M209.982 91.194l10.779-5.998 5.983 10.805L215.965 102z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#9B51E0",
    d: "M172.577 62.445l3.867-11.735 11.706 3.876-3.867 11.735z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 139.982,
    cy: 31.067,
    rx: 3,
    ry: 3.007,
    fill: "#33BB40"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 212.982,
    cy: 43.096,
    rx: 3,
    ry: 3.007,
    fill: "#FFCA28"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.982,
    cy: 94.219,
    rx: 3,
    ry: 3.007,
    fill: "#9B51E0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M139.482 64.147l4.16 8.797 9.631 1.247-7.061 6.684 1.793 9.568-8.523-4.666-8.522 4.666 1.793-9.568-7.061-6.684 9.631-1.247 4.159-8.797zM49.462 29.092L32.25 9.853l9.188-8.22L58.65 20.872z",
    fill: "#FFCA28"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#33BB40",
    d: "M84.688 73.884l-4.137 11.613-24.34-8.67 4.137-11.613z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 122.503,
    cy: 12.665,
    r: 3,
    transform: "rotate(178.883 122.503 12.665)",
    fill: "#FFCA28"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.201,
    cy: 49.295,
    r: 3,
    transform: "rotate(178.883 39.2 49.295)",
    fill: "#368FFE"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.908,
    cy: 84.846,
    r: 3,
    transform: "rotate(178.883 113.908 84.846)",
    fill: "#FF5F01"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M108.822 53.26l-8.628-4.284-8.268 4.943 1.41-9.53-7.256-6.336 9.498-1.604 3.784-8.859 4.461 8.538 9.594.861-6.741 6.881 2.146 9.39z",
    fill: "#9B51E0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.948 111.771l-8.628-4.284-8.268 4.942 1.41-9.529-7.256-6.336 9.498-1.604 3.784-8.859 4.46 8.537 9.595.862-6.741 6.881 2.146 9.39z",
    fill: "#FF5F01"
  })));
};

export default SvgScratchHeaderRight;